export default __webpack_public_path__ + "static/media/undraw_forgot_password_gi2d.c19428a0.png";